var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3HappyHilite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "hilite",
    fill: "#4A90E2",
    cx: 34,
    cy: 34,
    r: 33
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 34,
    cy: 34,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,55.0189474 C22.3789474,55.0189474 12.9810526,45.6210526 12.9810526,34 C12.9810526,22.3789474 22.3789474,12.9810526 34,12.9810526 C45.6210526,12.9810526 55.0189474,22.3789474 55.0189474,34 C55.0189474,45.6210526 45.6210526,55.0189474 34,55.0189474 M34,10 C20.7621053,10 10,20.7621053 10,34 C10,47.2378947 20.7621053,58 34,58 C47.2378947,58 58,47.2378947 58,34 C58,20.7621053 47.2378947,10 34,10 M22.88,30 C24.4705684,30 25.76,31.2899368 25.76,32.88 C25.76,34.4710737 24.4705684,35.76 22.88,35.76 C21.2894316,35.76 20,34.4710737 20,32.88 C20,31.2899368 21.2894316,30 22.88,30 M20.6061192,42.2955989 C21.2713435,41.8018702 22.2108606,41.9408948 22.7045894,42.6061192 C25.424801,46.2711904 29.7057657,48.4738785 34.3563574,48.4738785 C38.8627319,48.4738785 43.0253164,46.4067567 45.7594596,42.9314973 C46.2716946,42.280416 47.2147487,42.1678589 47.86583,42.6800939 C48.5169113,43.1923288 48.6294685,44.135383 48.1172335,44.7864643 C44.8202096,48.9771787 39.7925794,51.4738785 34.3563574,51.4738785 C28.7459497,51.4738785 23.5758437,48.8136999 20.2955989,44.3940691 C19.8018702,43.7288447 19.9408948,42.7893276 20.6061192,42.2955989 Z M45.88,30 C47.4705684,30 48.76,31.2899368 48.76,32.88 C48.76,34.4710737 47.4705684,35.76 45.88,35.76 C44.2894316,35.76 43,34.4710737 43,32.88 C43,31.2899368 44.2894316,30 45.88,30 Z",
    id: "Fill-1",
    fill: "#76C450"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3HappyHilite);
export default __webpack_public_path__ + "static/media/3 Happy_hilite.588d85904faed54c5381c74fea372d8e.svg";
export { ForwardRef as ReactComponent };